module.exports = __webpack_public_path__ + "img/heibaimochoubiandai.min.6aeb3c07.png";